// extracted by mini-css-extract-plugin
module.exports = {"panelImageWrapper":"tabItemsImage_panelImageWrapper__4_01F","panelImg":"tabItemsImage_panelImg__YErYo"};